import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@common/components';
export const StatisticsCardSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <section className="mx-20 mb-20 flex h-80 items-center gap-12 rounded-medium bg-Gray-white p-8">{[1, 2, 3, 4].map(_temp)}</section>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
function _temp(index) {
  return <div key={index} className="group flex flex-1 flex-col items-center justify-center gap-2 rounded-medium py-8"><Skeleton className="w-60 rounded-small mobile-sm:typo-caption1" typo="body4" /><Skeleton className="w-50 rounded-small mobile-sm:typo-body4" typo="body2" /></div>;
}